'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Link } from '@/components/ui/link/link.component';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { Card } from '@/components/ui/card.component';
import { IndexItem } from '@/types/index/index-list.type';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface SeoExamUfCardProps {
  exam: IndexItem;
  filterTerm?: string;
  isFirst?: boolean;
}

export function SeoExamUfCard({ exam, filterTerm, isFirst = false }: SeoExamUfCardProps) {
  const term = (filterTerm ?? '').trim().toLowerCase();
  const cities = term
    ? (exam?.cities ?? []).filter(
        (city) =>
          city?.city?.toLowerCase().includes(term)
          || city?.slug?.toLowerCase().includes(term)
          || city?.state_abbr?.toLowerCase().includes(term),
      )
    : (exam?.cities ?? []);

  return (
    <Card key={exam.key} className={`md:mt-6 pt-0 border-x-0 sm:px-16 ${isFirst ? 'border-t' : 'border-t-0'} md:px-6 md:border-t md:border-b md:border-x rounded-none md:rounded-xl`}>
      <ul className="mt-4 space-y-4">
        {cities.length > 0
          ? cities.map((city, index) => (
              <li key={city?.slug}>
                <Link
                  prefetch={false}
                  href={`/exames/${exam?.slug}-em-${city?.slug}/`}
                  data-testid={DataTestIdEnum.INDEXING_CARD_CITY_NAME}
                  className="text-green-500 font-bold hover:underline"
                  data-analytics-event={AnalyticsEnum.CLICK_EXAM_BY_CITY}
                  data-analytics-properties={JSON.stringify({ exame: exam.name, cidade: city.city, estado: city.state_abbr })}
                >
                  {`${formatToTitleCase(String(exam?.name))} em ${city?.city} - ${city?.state_abbr}`}
                </Link>
                {index !== cities.length - 1 && <hr className="mt-4" />}
              </li>
            ))
          : term
            ? (
                <li>
                  <p className="text-gray-600" role="status">
                    Nenhuma cidade encontrada para o filtro informado.
                  </p>
                </li>
              )
            : null}
      </ul>
    </Card>
  );
}
